import React from 'react';
import PropTypes from 'prop-types';

const StaticLoaderIconSVG: React.FC<{ size?: number; color?: string; }> = ({ size, color }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.81355 0.978394C10.8283 0.978394 11.1978 2.31514 10.3272 2.83638C10.172 2.92931 9.99447 2.97839 9.81355 2.97839H6C3.79086 2.97839 2 4.76925 2 6.97839C2 6.99559 2.00011 7.01276 2.00032 7.0299C2.006 7.47929 1.82147 7.92879 1.43588 8.15965C0.851673 8.50942 0.0895762 8.22137 0.026255 7.54341C0.00888213 7.35741 0 7.16894 0 6.97839C0 3.66469 2.68629 0.978394 6 0.978394H9.81355Z" fill={color} />
    <path d="M10.552 10.9784C10.37 10.9784 10.1914 11.0281 10.0356 11.1221C9.16813 11.6453 9.53904 12.9784 10.552 12.9784H14C17.3137 12.9784 20 10.2921 20 6.97839C20 6.8582 19.9965 6.73883 19.9895 6.62039C19.9484 5.92185 19.1667 5.61459 18.5675 5.976L18.4926 6.02117C18.1649 6.21879 18 6.59577 18 6.97839C18 9.18753 16.2091 10.9784 14 10.9784H10.552Z" fill={color} />
    <path d="M7.85714 6.97841C7.85714 6.18943 7.21755 5.54984 6.42857 5.54984C5.63959 5.54984 5 6.18943 5 6.97841C5 7.76739 5.63959 8.40698 6.42857 8.40698C7.21755 8.40698 7.85714 7.76739 7.85714 6.97841Z" fill={color} />
    <path d="M9.99986 5.54984C10.7888 5.54984 11.4284 6.18943 11.4284 6.97841C11.4284 7.76739 10.7888 8.40698 9.99986 8.40698C9.21088 8.40698 8.57129 7.76739 8.57129 6.97841C8.57129 6.18943 9.21088 5.54984 9.99986 5.54984Z" fill={color} />
    <path d="M15.0002 6.97841C15.0002 6.18943 14.3606 5.54984 13.5716 5.54984C12.7827 5.54984 12.1431 6.18943 12.1431 6.97841C12.1431 7.76739 12.7827 8.40698 13.5716 8.40698C14.3606 8.40698 15.0002 7.76739 15.0002 6.97841Z" fill={color} />
  </svg>
);

StaticLoaderIconSVG.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

StaticLoaderIconSVG.defaultProps = {
  color: 'var(--k-ds-color-grey-900)',
  size: 14,
};

export default StaticLoaderIconSVG;
